function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#E6AC39"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.294 18.003a.999.999 0 01.074 1.994l-.074.003H.999a.999.999 0 01-.075-1.994l.075-.003h17.295zM15.328 3.255a.838.838 0 01.072 1.672l-.072.003h-3.23a5.341 5.341 0 00-5.342 5.197l-.002.142v4.788a.838.838 0 01-1.672.072l-.003-.072V10.27a7.016 7.016 0 016.862-7.012l.157-.002h3.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.671 11.882a.838.838 0 011.255 1.107l-.054.06-3.255 3.35a.838.838 0 01-1.124.071l-.06-.053-3.45-3.35a.838.838 0 011.106-1.255l.06.053L6 14.631l2.672-2.749zM12.775.254A.838.838 0 0113.9.184l.06.053 3.35 3.255c.313.304.338.79.071 1.124l-.053.06-3.35 3.45A.838.838 0 0112.72 7.02l.054-.06 2.766-2.85-2.749-2.672a.838.838 0 01-.07-1.124l.053-.06z"
}));

function SvgRoofToggleHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default SvgRoofToggleHover;